import { apiCallStatus } from 'helpers/constants';
import { EXPORT_MESSAGE_ARCHIVE } from './constants';

const initialState = {
    loadingStatus: null,
    data: null,
    error: null
};

export function ExportMessageArchiveReducer(state = initialState, action) {
    switch (action.type) {
        case EXPORT_MESSAGE_ARCHIVE:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    data: action.data,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    data: null,
                    error: action.error
                };
            }
            break;
        default:
            return state;
    }
}
